import Creatable from './Creatable';

export default Creatable;
